/**
 * @generated SignedSource<<9aac152f3d8fac54f81d87584de3a29d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuRingSizeUnitSelector_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useRingMeasurementType_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuRingSizeUnitSelector_itemSearch";
};
export type SbSharedRefineMenuRingSizeUnitSelector_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuRingSizeUnitSelector_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuRingSizeUnitSelector_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuRingSizeUnitSelector_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRingMeasurementType_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "33a27257dad99f62db884eb2d8ffa9c7";

export default node;
